import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Roboto', sans-serif;
    padding: 0 32px 24px;
`;

export const Content = styled.div`
`;

export const Title = styled.h2`
    font-size: 22px;
    color: #000;
    margin-bottom: 24px;
    font-family: 'Bebas Neue';
    font-weight: 500;
`;

export const Summary = styled.div`
    color: #000;
    margin-bottom: 12px;
    text-align: left;
    font-size: 18px;
`;

export const BioContainer = styled.div`
    font-size: 18px;
    //padding: 24px;
`;